<!-- 
CathayCustInfoModal.vue
功能：泰好客定義視窗
作者：i9400538 陳博承
完成：2022-05-13
-->
<template>
  <div id="cathay-cust-info-modal" class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog" style="width: 650px;">
      <div class="modal-content">
        <div class="modal-header">
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <div>
            <span class="cathay-cust-info-title text-green">泰好客</span>
            <span class="cathay-cust-title-circle bg-green1 mr-1">&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="cathay-cust-title-circle bg-orange1">&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <label class="cathay-cust-label">高促約潛力</label>
            <span class="cathay-cust-title-circle bg-green2 mr-1">&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="cathay-cust-title-circle bg-orange2">&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <label class="cathay-cust-label">中高促約潛力</label>
            <div class="padding-top-use">
              <span>快速掌握您客戶各商品類型的促約潛力，並作為您優先拜訪決策，提升拜訪效率</span>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="insurance-row row">
            <table id="cathay-cust-info-icon" class="table-info">
              <tbody>
                <tr>
                  <td class="pr-2">
                    <span class="bg-green1">住</span>
                    <label>住院險</label>
                  </td>
                  <td class="pr-2">
                    <span class="bg-green1">手</span>
                    <label>手術險</label>
                  </td>
                  <td class="pr-2">
                    <span class="bg-green2">實</span>
                    <label>實支實付險</label>
                  </td>
                  <td>
                    <span class="bg-green2">意</span>
                    <label>意外險</label>
                  </td>
                  <td>
                    <span class="bg-green1">重</span>
                    <label>重疾險</label>
                  </td>
                </tr>
                <tr>
                  <td class="padding-top-use">
                    <span class="bg-green2">長</span>
                    <label>長照險</label>
                  </td>
                  <td class="padding-top-use">
                    <span class="bg-gray">壽</span>
                    <label>壽險</label>
                  </td>
                  <td class="padding-top-use">
                    <span class="bg-orange1">儲</span>
                    <label>儲蓄險</label>
                  </td>               
                  <td class="padding-top-use">
                    <span class="bg-orange2">投</span>
                    <label>投資型保險</label>
                  </td>
                  <td class="padding-top-use">
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="padding-top-use">
              <table id="cathay-cust-info-text" class="table datatable table-striped">
                <thead>
                  <tr>
                    <th width="25%" class="text-center">類別分檻</th>
                    <th width="75%" class="text-center">應用說明</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>高促約潛力</td>
                    <td>篩選該商品類型模型促約潛力為全客戶前10%，您可以獲得再購機率高及特定數量的名單，作為優先拜訪的對象</td>
                  </tr>
                  <tr>
                    <td>中高促約潛力</td>
                    <td>篩選該商品類型模型促約潛力為全客戶前11~20%，您可以獲得再購機率佳及較多數量的名單，排定您的拜訪計畫</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="div-margin-left">
              <span>註：泰好客資訊於每月2號進行更新，如客戶為新客，在資料更新前將全部顯示灰底，待次月資料更新後進行調整。</span>
            </div>            
            <div class="padding-top-use div-margin-left text-green">
              <div v-for="(item, index) in memo" :key="`memo-${index}`">
                <span>{{
                  `${item.description + item.contact}分機${item.contact_tel}`
                }}</span>
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonMixin } from "@/mixins/common";
import { getContactInfo } from "@/service";
export default {
  name: "CathayCustInfoModal",
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  watch: {
    open: function(val) {
      if (val) {
        //this.registerHanlink(); // for hard word
      }
    }
  },
  data() {
    return {
      memo: [],
    };
  },
  mounted() {
    getContactInfo(this.$store.state.userInfo.id, "行銷分泰好客").then(
      (result) => {
        if (result.header && result.header.status === "200") {
          this.memo = result.body.data;
        }
      }
    );
  },
};
</script>
<style lang="scss" scoped>
.cathay-cust-info-title {
  font-size: 30px;
  font-weight: 600;
  margin-bottom: 0.5rem;
  margin-right: 0.5rem;
  font-family: inherit;
  line-height: 1.2;
}

.cathay-cust-title-circle {
  border-radius: 50%;
  width: 6px;
  height: 6px;
}

.cathay-cust-label {
  padding-left: 0.5rem;
  padding-right: 1.2rem;
}

.table-info {
  // width: 100%;
  border-collapse: collapse;
  margin-left: 1.2rem;
  tbody {
    tr > td {
      font-size: 18px;
    }
    td > label {
      padding-left: 0.5rem;
    }
    td > span {
      border-radius: 50%;
      width: 36px;
      height: 36px;
      padding: 8px;
      color: #fff;
      text-align: center;
      font: 20px Arial, sans-serif;
    }
  }
}

.padding-top-use {
  padding-top: 1.5rem;
}

.bg-green1 {
  background-color: rgb(0, 128, 0);
}

.bg-green2 {
  background-color: rgb(146, 208, 80);
}

.bg-gray {
  background-color: rgb(230, 230, 230);
}

.bg-orange1 {
  background-color: rgb(245, 136, 26);
}

.bg-orange2 {
  background-color: rgb(244, 177, 131);
}

.text-center {
  text-align: center;
}

.table.datatable {
  width: 90%;
  margin-left: 1.2rem;
  tbody {
    tr > td {
      &:first-child {
        padding-top: 10px;
      }
    }
  }
}

.div-margin-left {
  margin-left: 1.2rem;
}

.modal-body {
    padding: 1rem !important;
}
</style>